import { Modal } from "@mantine/core"
import { StackForm } from "../../../components/purchase-sales/stack-form"
import { CancelOrderModal } from "../../../components/order-cancel/CancelOrderModal"
import { SupplierSalesDynamicConfirmForm } from "../../../components/supplier-sales/confirm-form"
import { DeliveryCreateModal } from "../../../components/supplier-sales-create-delivery"
import { SupplierSalesDynamicReviewForm } from "../../../components/supplier-sales/review-form"
import { IOrderPlus } from "../../../models/Order"
import { ActionState } from "./types"

type Props = {
  action: ActionState
  setAction: (next: ActionState) => void
  parentActions: any[]
  setParentActions: (next: any[]) => void
  reload: () => Promise<void> | void
  setChecked: (next: IOrderPlus[]) => void
  checked: IOrderPlus[]
  onConfirmCancel: (record: IOrderPlus) => void
  cancelBusy: boolean
}

export function SupplierSalesActionModals({
  action, setAction, parentActions, setParentActions, reload, setChecked, checked, onConfirmCancel, cancelBusy,
}: Props) {
  // The form components keep their legacy `setActions([kind, record])` contract; an empty array closes.
  const close = () => setAction({ kind: "none" })
  const setLegacyAction = (next: any[]) => {
    if (!next || next.length === 0) close()
  }
  const onCancelParent = () => setParentActions([])
  const record = action.kind === "none" ? undefined : action.record

  return (
    <>
      <Modal
        opened={action.kind === "confirm" || action.kind === "reject"}
        onClose={close}
        withCloseButton={false}
        size={480}
        padding={0}
        radius="lg"
        centered
      >
        <SupplierSalesDynamicConfirmForm
          action={record}
          setActions={setLegacyAction}
          constant={action.kind === "reject" ? "reject" : "confirm"}
          reload={reload}
        />
      </Modal>

      <Modal opened={action.kind === "reviewed"} onClose={close} withCloseButton={false} size={480} padding={0} radius="lg" centered>
        <SupplierSalesDynamicReviewForm action={record} setActions={setLegacyAction} reload={reload} />
      </Modal>

      <CancelOrderModal
        opened={action.kind === "cancel"}
        code={String(record?.salesCode ?? record?.purchaseCode ?? "-")}
        loading={cancelBusy}
        onClose={close}
        onConfirm={() => record && onConfirmCancel(record)}
      />

      <Modal opened={parentActions[0] === "delivery"} onClose={onCancelParent} withCloseButton={false} size={640} padding={0} radius="lg" centered>
        <DeliveryCreateModal
          orderIds={(parentActions[1] ?? []).map((c: { id: string }) => c.id)}
          orderCodes={(checked ?? []).map((c) => String(c.salesCode ?? c.id))}
          onCancel={onCancelParent}
          onSuccess={() => {
            setChecked([])
            reload()
            onCancelParent()
          }}
        />
      </Modal>

      <Modal opened={parentActions[0] === "backorder"} onClose={onCancelParent} withCloseButton={false} size="80%" padding={0} radius="lg" centered>
        <StackForm action={parentActions} onCancel={onCancelParent} reload={reload} />
      </Modal>
    </>
  )
}
